import React from 'react';
import BrokerageAddressField from './BrokerageAddressField';
import { FormLabel, Grid } from '@mui/material';
import { GooglePlacesAutocomplete } from '@/components/selects/GooglePlacesAutocomplete';
import { useFormikContext } from 'formik';

const BrokerageAddress = ({ canEdit = true }) => {
	const { setFieldValue } = useFormikContext();

	const handlePlaceSelect = async (params) => {
		if (!params || !canEdit) return;

		setFieldValue('streetAddress', (params.addressLine1 ?? '').trim());
		setFieldValue('suburb', (params.suburb ?? '').trim());
		setFieldValue('city', (params.city ?? '').trim());
		setFieldValue('postcode', (params.postcode ?? '').trim());
	};

	return (
		<>
			<Grid size={12}>
				<FormLabel>Search Address</FormLabel>
				<GooglePlacesAutocomplete
					disabled={!canEdit}
					onSelectAddress={(params) => {
						handlePlaceSelect(params);
					}}
				/>
			</Grid>

			{['streetAddress', 'suburb', 'city', 'postcode'].map((field) => (
				<BrokerageAddressField key={field} {...{ field, canEdit }} />
			))}
		</>
	);
};

export default BrokerageAddress;
